[
  {

    "name": "dashboard",
    "icon": "insights",
    "path": "/dashboard",
    "config_path": "assets/dashboard-config/dashboard-config.json",
    "children": [
        {
          "name": "page1",
          "icon": "timeline",
          "path": "chat",
          "config_path": "chat-config/chat-config.json",
          "configFile": "chat-config.json"
        },
        {
          "name": "page2",
          "icon": "timeline",
          "path": "page2",
          "config_path": "assets/dashboard-config/customer-overview.json",
          "configFile": "customer-overview.json"
        },
        {
          "name": "page3",
          "icon": "timeline",
          "path": "page3",
          "config_path": "assets/dashboard-config/opportunity-simulator-config.json",
          "configFile": "opportunity-simulator-config.json"
        }
      ]
  },
  {
    "name":"Chat",
    "icon":"chat",
    "path":"chat"
  }

]